import React from 'react'
import { connect } from 'react-redux'
import config from '../../../config.json'
import toJS from '../../../containers/general/toJS.js';
import PageApps from '../presents/PageApps.jsx';

const mapStateToProps = state => ({
    apps: state.getIn(['wpServerData', 'data', 'data', 'apps'])
})

const PageAppsContainer = ({saveState, status, apps}) => {
    let routes = []

    if(apps?.push?.enabled){
        routes.push("push")
    }

    return (
        <PageApps
            pageName={config.routes.apps.name}
            saveState={saveState}
            usedRoutes={routes}
            status={status}
        />
    )
}


export default connect(mapStateToProps)(toJS(PageAppsContainer))